
export const filtrosTypography = {
    color: 'black',
    fontWeight: '600',
    minWidth: '50px',
    fontSize: '13px'
}

export const boxInputs = {
    display: 'flex',
    alignItems: 'center'
}
